export default {
	TaxReturnSubmission: {
		Title: 'Tờ khai',
		TaxRegisButton: 'Nộp tờ khai',
		QuickSearchPlaceHolderContent:
			'Nhập mã giao dịch, mã giao dịch của TCT, mã số thuế, tên tờ khai, cơ quan thuế để tìm kiếm',
		SubmissionType: 'Loại tờ khai',
		FromDateIsNotAllowEmpty: 'Từ ngày không được để trống.',
		ToDateIsNotAllowEmpty: 'Đến ngày không được để trống',
		TheTaxCodeIsNotRegisteredServiceByTVAN:
			'Mã số thuế chưa đăng ký sử dụng dịch vụ khai thuế qua T-VAN MISA.',
		RegisteringTVANServiceIsInProcessing: value =>
			`Tờ khai đăng ký ${value} khai thuế điện tử đang chờ duyệt.`,
		TheTaxCodeHaveNotRegisteredSubmittingTaxReturn:
			'Mã số thuế chưa đăng ký tờ khai nộp qua mạng với cơ quan thuế.',
		DataEmpty: 'Chưa có tờ khai nào',
		RegisteringServiceButton: 'Đăng ký sử dụng dịch vụ',
		ViewRegisHistoryButton: 'Xem Lịch sử đăng ký',
		Received: 'Tiếp nhận',
		Accepted: 'Chấp nhận'
	},
	TaxReturnSubmissionDetail: {
		Title: 'Chi tiết tờ khai',
		AttachAdditionalReportBtn: 'Gửi kèm phụ lục',
		DownloadBtn: 'Tải xuống',
		Declaration: 'Tờ khai',
		TaxPeriod: 'Kỳ tính thuế',
		DeclarationType: 'Loại tờ khai',
		SubmitTimes: 'Lần nộp',
		FisrtTimes: 'Lần đầu',
		AddMore: 'Bổ sung',
		SubmissionId: 'Mã giao dịch',
		Status: 'Trạng thái',
		SubmitDate: 'Ngày gửi',
		NotiReceivedDateStepOne: 'Ngày tiếp nhận',
		NotiReceivedDateStepTwo: 'Ngày chấp nhận',
		RejectedDate: 'Ngày từ chối',
		AttachAppendx: 'Phụ lục đính kèm',
		ViewHistory: 'Xem lịch sử',
		ViewAll: 'Xem toàn bộ',
		BusinessName: 'Tham chiếu'
	},
	TaxRegis: {
		Title: 'Đăng ký tờ khai',
		TitleHaunt: 'Đăng ký địa bàn vãng lai',
		PlaceHolderSearch: 'Nhập tên tờ khai để tìm kiếm',
		PlaceHolderSearchHaunt:
			'Nhập tên cơ quan thuế, tên tờ khai để tìm kiếm',
		PlaceHolderSearchReport:
			'Nhập mã giao dịch, mã số thuế, tên tờ khai, cơ quan thuế để tìm kiếm',
		DoesNotHaveTaxReturnToRegister: 'Không còn tờ khai được phép đăng ký.',
		Nodata: 'Không có tờ khai đăng ký'
	},
	TaxReturnRegisHistory: {
		CreatedDate: 'Ngày đăng ký',
		SubmissionType: 'Loại đăng ký',
		TaxReturnName: 'Tên tờ khai',
		Dec_RegistrationDeclare: 'Đăng ký nộp tờ khai',
		Dec_StopDeclare: 'Đăng ký ngừng tờ khai',
		Dec_RegistrationDeclareHaunt: 'Đăng ký địa bàn vãng lai',
		Dec_StopDeclareHaunt: 'Đăng ký ngừng địa bàn vãng lai',
		TaxAgentName: 'Cơ quan thuế'
	},
	TaxRegisDetail: {
		TaxRegisDetailButton: 'Đăng ký tờ khai',
		TaxRegisDetailTitle: 'Đăng ký nộp tờ khai',
		TaxUnRegis: 'Ngừng nộp tờ khai'
	},
	TaxRegister: {
		TaxCodeIsNotRegis:
			'Mã số thuế chưa đăng ký sử dụng dịch vụ khai thuế điện tử.',
		WaitingStop:
			'Vui lòng đợi cơ quan thuế duyệt tờ khai đăng ký ngừng dịch vụ trước khi ký gửi Tờ khai',
		WaitingChange:
			'Vui lòng đợi cơ quan thuế duyệt tờ khai đăng ký thay đổi trước khi ký gửi Tờ khai',
		ErrorDuplicate: value =>
			`Tờ khai ${value} bị trùng lặp, vui lòng kiểm tra lại.`,
		ErrorDuplicateMonthQuarter: value =>
			`Tờ khai ${value} không được phép đăng ký nộp theo tháng và quý cùng lúc. Vui lòng chọn 1 loại kỳ kê khai`,
		ErrorExist: value => `Tờ khai ${value} đã đăng ký nộp qua mạng`,
		ErrorExistMonthQuarter: (
			taxReturnCode,
			periodExist,
			beginPeriod,
			period
		) =>
			`Tờ khai ${taxReturnCode} đã đăng ký nộp theo ${periodExist} kể từ ${beginPeriod}. Vui lòng ngừng tờ khai đã đăng ký trước khi đăng ký nộp tờ khai theo ${period}`,
		ErrorPending: value => `Tờ khai ${value} đang chờ phê duyệt`,
		ErrorPendingMonthQuarter: (value, value2) =>
			`Tờ khai ${value} đang chờ phê duyệt. Bạn không thể đăng ký tờ khai ${value2}`
	},
	Procedure: {
		Title: 'Quy trình khai thuế',
		Step1: 'Đăng ký sử dụng dịch vụ',
		Step1SubTitle:
			'Lập tờ khai đăng ký sử dụng dịch vụ khai thuế điện tử qua T-VAN MISA với cơ quan thuế',
		Step2: 'Đăng ký tờ khai nộp qua mạng',
		Step2SubTitle: 'Đăng ký với cơ quan thuế những tờ khai sẽ nộp qua mạng',
		Step3SubTitle: 'Nộp tờ khai XML qua T-VAN MISA',
		Step2Tooltip: 'Cơ quan thuế sẽ duyệt bản đăng ký trong vòng 15 phút',
		TaxReturnRegistrationIsInProcessing:
			'Tờ khai đăng ký thay đổi/bổ sung đang chờ duyệt. Vui lòng thử lại sau khi tờ khai được duyệt xong.'
	},

	TaxReturnSubmissionHistory: {
		Title: 'Lịch sử nộp tờ khai',
		Title2: 'Lịch sử nộp phụ lục',
		Subtitle:
			'Lưu ý: Với tờ khai thuế, trường hợp NNT nộp lại tờ khai/phụ lục nhiều lần, TCT sẽ ghi nhận tờ khai/phụ lục được chấp nhận lần gần nhất'
	},
	ConfirmTaxPaperNTNN: {
		Title: 'Chọn loại thuế cần nộp',
		WarningAtLest: 'Bạn phải chọn ít nhất 01 khoản nộp'
	},
	DescriptionIndividual:
		'Cá nhân, hộ kinh doanh không cần đăng ký dịch vụ T-VAN để nộp tờ khai.\nBạn có thể nộp tờ khai trực tiếp tại đây!'
};
